import { all, takeLatest, put } from 'redux-saga/effects';
import { requestStatisticsQuizzes,requestStatisticsFileQuizzes } from './api';
import { ststisticsQuizSuccess,downloadStatisticsExportFileSuccess } from './actions';

import {
    STATISTICS_QUIZ_ROUTE,
    DOWNLOAD_QUIZ_STATISTICS_EXPORT_FILE
} from './constants';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<*>>}
 */
function* getQuizStatistics(actionObj) {
  const qstatistic = yield requestStatisticsQuizzes(actionObj.fromToDates, actionObj.quizId);
  
  if (qstatistic){
    yield put( ststisticsQuizSuccess (qstatistic) );
  }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{fileLink, type}>>}
 */
function* getQuizFileStatistics(actionObj) {
    const fileLink = yield requestStatisticsFileQuizzes(actionObj.fromToDates, actionObj.quizId);

    if (fileLink) {
        yield put(downloadStatisticsExportFileSuccess(fileLink));
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchStatistics() {
    yield  takeLatest(STATISTICS_QUIZ_ROUTE, getQuizStatistics);
    yield  takeLatest(DOWNLOAD_QUIZ_STATISTICS_EXPORT_FILE, getQuizFileStatistics);
}

/**
 *
 * @returns {IterableIterator<AllEffect<IterableIterator<ForkEffect>>>}
 */
function* statisticsSaga(){
  yield all([
    watchStatistics()
  ]);
}

export default statisticsSaga;